import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class LimitedService {
  constructor() {}

  checkLimit(current: number, max: number): boolean {
    return current >= max
  }
}
